export function wordHint(str: string, percentage: number = 0.085): string {
  if (str.length <= 2) {
    return str;
  }

  const firstCharsCount = Math.round(str.length * percentage + 0.5);
  const lastCharsCount = Math.round(str.length * percentage);
  const firstChars = str.substring(0, firstCharsCount);
  const lastChars = str.substring(str.length - lastCharsCount);
  const middleChars = 'ˍ'.repeat(str.length - firstCharsCount - lastCharsCount);
  return `${firstChars}${middleChars}${lastChars}`;
}
